<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        label="Nome"
                        v-model="model.nome"
                        :validations="validations.nome"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Form
            :data="{ form, model }"
            :id="id"
            @handleSave="handleSave"
            ref="FormFatores"

        />
    </div>
</template>

<script>
// Components.
import Form from './components/Form'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { Form },
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number }
    },
    data: () => ({
        repositories: {
            formulaExame: null,
        },
        model: {
            nome: '',
            fatores: [],
        },
        form: {},
    }),
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    max: 100,
                    min: 3,
                },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading()

                this.repositories.formulaExame.edit(this.id)
                    .then(({ data }) => {

                        this.form = Object.assign(data.form)
                        this.model = Object.assign(data.model)
                      })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {

                this.setLoading()

                this.repositories.formulaExame.create()
                    .then(({ data }) => {

                        this.form = Object.assign(data.form)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.model.fatores.length == 0) {

                        this.showValidationNotification(
                            "Adicione ao menos um fator para salvar."
                        )

                        return false
                    }

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.formulaExame.update(this.id, this.prepareData())
                        : this.repositories.formulaExame.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
        handleSave(fatores) {

            this.model.fatores = fatores
        },
    },
    created() {

        this.repositories.formulaExame = this.getConectaSusRepository('exameLaboratorial.formulaExame')

        this.load()
    },
}
</script>